import { Toaster, toast, type ToasterProps } from "sonner";
import { cn } from "../utils";

export type ToastVariant = "success" | "error" | "warning" | "info";

export interface ToastMessage {
  title: string;
  description?: string;
  variant?: ToastVariant;
  actionLabel?: string;
  onAction?: () => void;
  duration?: number;
  id?: string | number;
}

export interface ToastProviderProps extends ToasterProps {
  className?: string;
}

export function ToastProvider({ className, richColors = true, position = "top-right", ...props }: ToastProviderProps) {
  return (
    <Toaster
      position={position}
      closeButton
      theme="light"
      richColors={richColors}
      toastOptions={{
        classNames: {
          toast: cn("border border-neutral-200 shadow-md rounded-lg", className),
          title: "font-semibold text-foreground",
          description: "text-neutral-600",
          actionButton: "text-sm font-semibold text-primary",
        },
      }}
      {...props}
    />
  );
}

export function showToast({ title, description, variant = "info", actionLabel, onAction, ...options }: ToastMessage) {
  toast(title, {
    description,
    action: actionLabel && onAction ? { label: actionLabel, onClick: onAction } : undefined,
    ...options,
    className: cn("border border-neutral-200"),
    classNames: {
      toast: cn(
        variant === "success" && "bg-emerald-50",
        variant === "error" && "bg-red-50",
        variant === "warning" && "bg-amber-50"
      ),
    },
  });
}

export { toast };
